import { person, phonePortrait, mail, barcode } from "ionicons/icons";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { ProfileAccessType } from "../../../../types/profile";
import { PatchUserType } from "../../../../types/welcome";
import { isRoleAccessFieldEnabled } from "../../../../helper/roleAccess";
import { FormGroup, TextField } from "../../../atoms/LoginTextField";
import Subtitle from "../../../atoms/Subtitle";
import { useConfig } from "../../../../contexts/ConfigContext";

interface InscriptionFieldsProps {
  access: ProfileAccessType;
  values: PatchUserType;
  setFieldValue: (key: string, value: string) => void;
  errors: any;
  touched: any;
}

const InscriptionFields = ({
  access,
  touched,
  errors,
  values,
  setFieldValue,
}: InscriptionFieldsProps): ReactElement => {
  const { t } = useTranslation();
  const { study } = useConfig();

  const { firstname, lastname, email, phone_number, external_id, nickname } =
    values;

  return (
    <FormGroup>
      <Subtitle>{t("home_identifier_title")}</Subtitle>
      {isRoleAccessFieldEnabled(access, "firstname") && (
        <TextField
          value={firstname}
          icon={person}
          type="text"
          error={touched.firstname && errors.firstname}
          onChange={(value) => setFieldValue("firstname", value)}
          placeholder={t("home_inscription_firstname")}
        />
      )}
      {isRoleAccessFieldEnabled(access, "lastname") && (
        <TextField
          value={lastname}
          icon={person}
          type="text"
          error={touched.lastname && errors.lastname}
          onChange={(value) => setFieldValue("lastname", value)}
          placeholder={t("home_inscription_lastname")}
        />
      )}
      {isRoleAccessFieldEnabled(access, "nickname") && (
        <TextField
          value={nickname}
          icon={person}
          type="text"
          error={touched.nickname && errors.nickname}
          onChange={(value) => setFieldValue("nickname", value)}
          placeholder={t("home_inscription_nickname")}
        />
      )}
      {/* {!study.is_gamified && isRoleAccessFieldEnabled(access, "email") && (
        <TextField
          icon={mail}
          value={email}
          type="text"
          error={touched.email && errors.email}
          onChange={(value) => setFieldValue("email", value)}
          placeholder={t("home_inscription_email")}
        />
      )}
      {!study.is_gamified && isRoleAccessFieldEnabled(access, "phonenumber") && (
        <TextField
          icon={phonePortrait}
          value={phone_number}
          type="text"
          error={touched.phone_number && errors.phone_number}
          onChange={(value) => setFieldValue("phone_number", value)}
          placeholder={t("home_inscription_phone")}
        />
      )} */}
      {isRoleAccessFieldEnabled(access, "external_id") && (
        <TextField
          icon={barcode}
          value={external_id}
          type="text"
          error={touched.external_id && errors.external_id}
          onChange={(value) => setFieldValue("external_id", value)}
          placeholder={t("home_inscription_external_id")}
        />
      )}
    </FormGroup>
  );
};

export default InscriptionFields;
